import { memo, useEffect, useRef } from 'react';

import { XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

import { SearchCommandVisualSearchDropzone } from '~/components/SearchCommand/SearchCommandVisualSearchDropzone';
import { SearchCommandVisualSearchHeader } from '~/components/SearchCommand/SearchCommandVisualSearchHeader';

export const SEARCH_COMMAND_VISUAL_SEARCH_TITLE_ID = 'search-command-visual-search-title';

export type SearchCommandVisualSearchPanelProps = {
  onClose: () => void;
  onSearch: (base64Image: string) => void;
};

export const SearchCommandVisualSearchPanel = memo(({ onClose, onSearch }: SearchCommandVisualSearchPanelProps) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    closeButtonRef.current?.focus();
  }, []);

  return (
    <div
      aria-labelledby={SEARCH_COMMAND_VISUAL_SEARCH_TITLE_ID}
      className="flex flex-col outline-none"
      data-testid="SEARCH_COMMAND_VISUAL_SEARCH_PANEL"
      role="dialog"
      tabIndex={-1}
    >
      <SearchCommandVisualSearchHeader titleId={SEARCH_COMMAND_VISUAL_SEARCH_TITLE_ID}>
        <Tooltip label="Close visual search">
          <IconButton
            adsIcon
            appearance="ghost"
            className="mr-1 rounded-full"
            color="gray"
            data-testid="SEARCH_COMMAND_VISUAL_SEARCH_PANEL_CLOSE"
            icon={XIcon}
            label="Close visual search"
            onClick={onClose}
            ref={closeButtonRef}
          />
        </Tooltip>
      </SearchCommandVisualSearchHeader>
      <div className="px-3 pb-3">
        <SearchCommandVisualSearchDropzone appearance="plain" onSearch={onSearch} />
      </div>
    </div>
  );
});

SearchCommandVisualSearchPanel.displayName = 'SearchCommandVisualSearchPanel';
